module.exports = __webpack_public_path__ + "img/handraw_coeur vide.670cafbf.svg";